<template>
  <div class="w-100">
    <legend v-if="label" class="col-form-label">
      {{ label }}
    </legend>

    <spinner v-if="loading" />

    <no-results-found v-else-if="!loading && !items.length" />

    <div v-else class="form-group p-2">
      <b-form-checkbox
          v-if="selectAllLabel"
          :checked="allSelected"
          :disabled="typeof disabled === 'function' ? false : disabled"
          :indeterminate="indeterminate"
          @change="onInput(allValues, $event)"
      >
        {{ selectAllLabel }}

        <b-link v-if="url" :to="url" target="_blank">
          <fa icon="edit" size="sm" />
        </b-link>
      </b-form-checkbox>
      <div v-else>
        {{ selectAllLabel }}
      </div>

      <div class="ml-3 py-1 row no-gutters">
        <template v-for="item in items">
          <tree-view
              v-if="item.children"
              :key="`${item['model_name']}_${item.id}`"
              :disabled="disabled"
              :error-prefix="errorPrefix"
              :errors="errors"
              :items="item.children"
              :key-by="keyBy"
              :readonly="readonly"
              :select-all-label="item[labelBy]"
              :url="item.url"
              :value="value"
              @input="$emit('input', $event)"
          />
          <div
              v-else
              :key="`${item['model_name']}_${item.id}`"
              class="px-1 col-3"
>
            <div class="custom-control custom-control-inline custom-checkbox">
              <input
                  :id="item.id"
                  :checked="value.includes(item[keyBy])"
                  :class="{'is-invalid': errors.has(`${errorPrefix}.${value.indexOf((item[keyBy]))}`)}"
                  :disabled="typeof disabled === 'function' ? disabled(item) : disabled"
                  class="custom-control-input"
                  type="checkbox"
                  @change="onInput(item[keyBy], $event.target.checked)"
              >
              <label
                  :class="{'is-invalid': errors.has(`${errorPrefix}.${value.indexOf((item[keyBy]))}`)}"
                  :for="item.id"
                  class="custom-control-label"
              >
                {{ item[labelBy] }}

                <b-link v-if="item.url" :to="item.url" target="_blank">
                  <fa icon="edit" size="sm" />
                </b-link>
                  <span v-if="item.foundation" class="text-secondary small" v-text="'(' + item.foundation.name + ')'" />
              </label>
            </div>

            <b-form-invalid-feedback
                v-if="errors.has(`${errorPrefix}.${value.indexOf(item[keyBy])}`)"
                :key="`${item['model_name']}_${item.id}_error`"
                :state="false"
                class="d-block"
                v-html="errors.get(`${errorPrefix}.${value.indexOf(item[keyBy])}`)"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import {difference, flattenDeep, intersection} from 'lodash'
import {Errors} from 'vform'
import Spinner from "@/components/Spinner";

export default {
  name: 'TreeView',
  components: {Spinner},
  props: {
    selectAllLabel: {
      type: String,
      default() {
        return this.$t('Select all')
      }
    },
    value: {
      type: Array,
      default: () => []
    },

    loading: {
      type: Boolean,
      default: false
    },

    errors: {
      type: Object,
      default: () => new Errors()
    },
    errorPrefix: {
      type: String,
      default: ''
    },

    items: {
      type: Array,
      default: () => []
    },
    keyBy: {
      type: String,
      default: 'id'
    },
    labelBy: {
      type: String,
      default: 'name'
    },

    label: {
      type: String,
      default: null
    },
    disabled: {
      type: [Boolean, Function],
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: null
    }
  },
  computed: {
    indeterminate() {
      return intersection(this.value, this.allValues).length > 0 && !this.allSelected
    },

    allValues() {
      return flattenDeep(this.extractLeaves(this.items));
    },

    allSelected() {
      return !difference(this.allValues, this.value).length
    }
  },

  methods: {
    extractLeaves(items) {
      return items.map(item => {
        if (item.children) {
          return this.extractLeaves(item.children);
        }

        return item[this.keyBy];
      })
    },

    onInput(input, checked) {
      let items = Array.isArray(input) ? input : [input];

      if (checked) {
        this.$emit('input', Array.from(new Set([...this.value, ...items])));
      } else {
        let values = new Set(this.value);
        items.forEach(Set.prototype.delete, values);
        this.$emit('input', Array.from(values));
      }

    }
  }
}
</script>
<style scoped>
.form-group {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
